import React from "react";
import AdminPage from "../AdminPage";
import useAdminList from "../useAdminList";
import FoundersVerifiedData from "../FoundersVerifiedData/FoundersVerifiedData";

const COPY = {
  title: "Verified Founders",
  subtitle: "You Can See Detail About Verified Founders",
  searchPlaceholder: "Search Here",
};

const FoundersVerified = () => {
  const { items, loading, searchValue, setSearchValue } = useAdminList(
    "getUsers",
    "fullName"
  );

  return (
    <AdminPage
      title={COPY.title}
      subtitle={COPY.subtitle}
      loading={loading}
      search={{
        value: searchValue,
        onChange: setSearchValue,
        placeholder: COPY.searchPlaceholder,
      }}
    >
      <FoundersVerifiedData driverData={items} />
    </AdminPage>
  );
};

export default FoundersVerified;
